import { useIsAdmin as useIsTenantContextAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { useIsSiteAdmin as useIsTenantContextSiteAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-site-admin/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createHook } from '@atlassian/react-sweet-state';
import { PermissionsStore } from './PermissionsContainer.tsx';
import { createPermissionHook } from './createPermissionHook.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { functionWithCondition } from '@jira/platform__utils-feature-flagging-utils/src/utils/function-with-condition/index.tsx';

/**
 * @deprecated use src/packages/polaris/component-permissions-store/src/controllers/permissions/hooks/useIsPreviewContributorMode.tsx
 */
const useIsInContributorPreviewMode = createHook(PermissionsStore, {
	selector: (state) => state.isPreviewContributorMode,
});

const useIsSiteAdminOld = (): boolean => {
	const isSiteAdmin = useIsTenantContextSiteAdmin();
	const [isInContributorPreviewMode] = useIsInContributorPreviewMode();
	return isSiteAdmin && !isInContributorPreviewMode;
};

export const useIsAdmin = (): boolean => {
	const isAdmin = useIsTenantContextAdmin();
	const [isInContributorPreviewMode] = useIsInContributorPreviewMode();
	return isAdmin && !isInContributorPreviewMode;
};

// POL-23563: gate OFF → legacy site-admin check; ON → Jira-admin check.
// Centralises the vortex-migration switch so consumers don't need inline fg() calls.
export const useIsJiraAdminWithContributorMode: () => boolean = functionWithCondition(
	() => fg('jpd_polaris_vortex_admin_migration'),
	useIsAdmin,
	useIsSiteAdminOld,
);

export const useCanManageGlobalFields = (): boolean => {
	const isAdmin = useIsAdmin();
	return isAdmin;
};

const useCanCreateProjectPermission = createPermissionHook('CREATE_PROJECT');

export const useCanCreateProject = (): boolean => {
	const [canCreateProject] = useCanCreateProjectPermission({});
	return canCreateProject;
};
